// RITA-1585/RITA-1602 — Adresse der Kachel „Einstellungen › Handbuch“ mit Kapitel: Ziel des Links „Ganzes Handbuch im neuen
// Tab öffnen“ und Einstieg der Kachel. Pfad-Strings nur aus routes/paths.ts; Kapitel als Abfrageparameter, wie
// andere Unteransichten im PRM (`?bereich=`, `?vorgang=`).
import { PagePathname } from '../../../routes/paths';
import { gueltigeKapitelwahl, Kapitelwahl } from './handbuecher';

export const HANDBUCH_PARAMETER = 'handbuch';
export const KAPITEL_PARAMETER = 'kapitel';
export const ABSCHNITT_PARAMETER = 'abschnitt';

/** Mit `abschnittId` landet die Kachel beim genannten Unterkapitel (Verweis aus der Leiste auf ein anderes Handbuch). */
export function handbuchAdresse(wahl: Kapitelwahl, abschnittId?: string): string {
  const parameter = new URLSearchParams({ [HANDBUCH_PARAMETER]: wahl.handbuchId, [KAPITEL_PARAMETER]: wahl.kapitelId });
  if (abschnittId) parameter.set(ABSCHNITT_PARAMETER, abschnittId);
  return `${PagePathname.handbuch}?${parameter.toString()}`;
}

/** Kapitel aus der Adresse; fehlt eines der beiden oder gibt es die Wahl nicht, null (dann gilt das gemerkte Kapitel). */
export function kapitelwahlAusAdresse(parameter: URLSearchParams): Kapitelwahl | null {
  return gueltigeKapitelwahl(parameter.get(HANDBUCH_PARAMETER), parameter.get(KAPITEL_PARAMETER));
}
